<template>
<div class="play-back-wrap">
  <van-list
    v-model="loading"
    :finished="finished"
    :error.sync="error"
    :loading-text="lang.loading"
    :error-text="lang.error"
    @load="getHostVideo"
  >

      <div class="play-back" v-if="playBackList && playBackList.length > 0">
        <div
            class="play-back-item"
            v-for="(item,index) of playBackList"
            :key="item.id + item.liveName"
            @click="viewLive(item.id)"
        >
            <div class="item-content global_pointer">
                <img
                    class="item-content-img"
                    v-lazy="handleImg({ url: item.liveImg.url, width: 702, height: 702 })"
                    alt=""
                />
                <div class="item-content-top">
                    <div
                    v-if="item.liveStatus.code === StatusLive"
                    class="live-icon live">
                    <img src="@/assets/imgs/anchor/livestatus.png" alt="">
                    <span v-if="item.liveStatus.code === StatusLive">{{ lang.live }}</span>
                    <span v-if="item.liveStatus.code === 1">{{ lang.upcoming }}</span>
                  </div>
                  <div
                      class="item-content-title"
                      v-if="item.store.countryName || item.store.cityName"
                  >
                      <img
                          class="item-content-title-icon"
                          src="https://fr-static.shopshops.top/20200328/icon_home_shop_address_white14x14@3x.123ad92fe39e1602.png"
                          alt=""
                      />
                      <span v-if="item.store.countryName">{{ item.store.countryName }}</span>
                      <span style="margin: 0 4px;">|</span>
                      <span v-if="item.store.cityName">{{ item.store.cityName }}</span>
                  </div>
                </div>
                <div class="item-content-bottom">
                  <div class="item-content-desc">
                      {{ item.maxUserNum }} {{ lang.watch }} {{ item.merchandiseNum }}
                      {{ lang.goods }}
                  </div>
                </div>
                <!-- <img
                    class="i-play"
                    src="https://fr-static.shopshops.top/20200328/icon_play56x56@2x.07a400e47d571826.png"
                    alt="播放按钮"
                /> -->
            </div>
            <div class="item-title">{{ item.liveName}}</div>
            <div class="item-time" v-if="item.liveStatus.code === 4 || item.liveStatus.code === 2">
                {{
                    $moment(new Date(item.startTime)).format('MMMM D, yyyy, h:mmA')
                
                }}
            </div>
            <div class="item-time" v-else>
                {{
                    $moment(new Date(item.bookStartTime)).format('MMMM D, yyyy, h:mmA')
                }}
            </div>
        </div>
    </div>
    <van-empty
      v-if="showEmpty"
      class="custom-image"
      image="https://fr-static.shopshops.top/20210401/empty.e9e968f9158374aa.png"
      image-size="90"
      description=""
    />
  </van-list>
</div>
</template>

<script>

import api from "@/api/api_list";
import { Empty, List, Button } from 'vant'
const StatusLive = 2 // 直播
export default {
    name: 'PlayBack',
    components: {
        [Empty.name]: Empty,
        [List.name]: List,
        [Button.name]: Button,
    },
    data() {
        return {
            StatusLive,
            pages: 0,
            page: 0,
            error: false,
            loading: false,
            finished: false,
            collecting: false,
            lang: this.$t('message.anchor'),
            hostId: '',
            playBackList: [],
            showEmpty: false,
            revpLoading: false,
        }
    },
    mounted() {
        this.hostId = this.$route.query.hostId
    },
    methods: {
        viewLive(topicId) {

            this.$router.push({path: `/app/room/${topicId}`})
        
        },
        // 直播、预告、回放
        async getHostVideo() {
            if (this.finished) return
            this.page++
            try {
                const params = {
                    hostId: this.hostId,
                    isSelectPreLive: 1,
                    pageSize: 10,
                    pageNum: this.page
                }
                const { code, result } = await api.get_host_videos(params)
                this.loading = false
                if (code) return
                this.pages = result.pages
                this.playBackList = [...this.playBackList, ...result.data]
                if (!this.playBackList.length) {
                    this.showEmpty = true
                }
                if (!result.isHasNext) {
                    this.finished = true
                }
            } catch(e) {
                this.error = true
                console.log(e)
                if (!this.playBackList.length) {
                    this.showEmpty = true
                }
            }
        },
        async remind(video, index) {
            if (!video.remindStatus && typeof video.remindStatus !== 'undefined') {
                return;
            }
            this.revpLoading = true
            try {
                const { code, result } = await api.follow_prelive_remind({ liveId: video.id, source: '主播主页' })
                if (!code) {
                    this.$set(this.playBackList[index], 'remindStatus', 0)
                }
            } catch(e) {
                console.log(e)
            } finally {
                this.revpLoading = false
            }
        }
    }
}
</script>
<style lang="less" scoped>
.play-back-wrap{
  min-height: 400px;
  background: #000000;
  .van-empty{
    padding: 80px 0;
  }
  .play-back {
      padding: 10px 12px 20px;
      background-color: #000000;
      &-title {
          font-size: 16px;
          color: #161a1a;
          font-weight: 600;
          padding: 0 0 15px 4px;
          margin-top: 22.5px;
          display: flex;
          align-items: center;
          align-content: center;
          &-img {
              width: 16px;
              height: 16px;
          }
          &-text {
              margin-left: 6px;
          }
      }
      &-item {
          margin-bottom: 22.5px;
          .item-content {
              margin: 0 auto;
              width: 350px;
              height: 350px;
              overflow: hidden;
              position: relative;
              border-radius: 8px;
              .i-play {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  width: 28px;
                  height: 28px;
                  transform: translate(-50%, -50%);
              }
              &-img {
                  width: 100%;
                  height: 100%;
              }
              &-top{
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  height: 48px;
                  background-image: linear-gradient(to bottom, rgba(0,0,0,.5) ,transparent);
                  .live-icon{
                      position: absolute;
                      top: 8px;
                      left: 8px;
                      padding: 0 8px;
                      height: 19px;
                      text-align: center;
                      line-height: 19px;
                      color: #39D2D6;
                      border-radius: 4px;
                      font-size: 12px;
                      font-family: "TradeGothicLT";
                      background-color: #000000;
                      img{
                         width: 10px;
                         height: 10px;
                         line-height: 19px;
                         margin-right: 2.5px;
                      }
                  }
              }
              &-bottom{
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  height: 48px;
                  background-image: linear-gradient(to bottom, transparent, rgba(0,0,0,.5));
                  font-family: "TradeGothicLT";
              }
              &-title {
                  font-size: 12px;
                  color: #fff;
                  position: absolute;
                  top: 8px;
                  right: 8px;
                  display: flex;
                  align-content: center;
                  align-items: center;
                  font-family: "TradeGothicLT";      
                  &-icon {
                      width: 14px;
                      height: 14px;
                      margin-right: 3px;
                  }
              }
              &-desc {
                  font-size: 12px;
                  color: #ffffff;
                  position: absolute;
                  bottom: 8px;
                  right: 8px;
              }
              .rsvp{
                  position: absolute;
                  right: 8px;
                  bottom: 8px;
                  width: 54px;
                  height: 28px;
                  line-height: 28px;
                  text-align: center;
                  color: #ffffff;
                  border-radius: 4px;
                  font-family: 'TradeGothicLT-Bold';
              }
              .revp-btn{
                  width: 54px;
                  height: 28px;
                  border-radius: 4px;
                  vertical-align: top;
                  padding: 0;
                  font-size: 12px;
              }
          }
          .item-title {
              color: #ffffffe6;
              font-size: 16px;
              height: 20px;
              line-height: 20px;
              margin-top: 8px;
              font-weight: 600;
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              text-align: left;
          }
          .item-time {
              color: #666666;
              font-size: 12px;
              margin-top: 6px;
              text-align: left;
              font-family: "TradeGothicLT";
          }
      }
  }
}
</style>
